import type { HistoryEntity } from './history-utils/index.ts'

export const loadHistoryEntity: HistoryEntity = {
  eventLabels: {
    end_company_assigned: 'End company assigned',
    end_company_removed: 'End company removed',
    haulier_assigned: 'Haulier assigned',
    haulier_removed: 'Haulier removed',
    order_confirmation_deleted: 'Order confirmation deleted',
    order_confirmation_generated: 'Order confirmation generated',
  },
  fieldLabels: {
    company: 'Customer company changed',
    dangerous_goods: 'Dangerous Goods (ADR) enabled',
    dangerous_goods_cost: 'Dangerous Goods (ADR) enabled',
    xero_bill_location: 'Xero bill connected',
  },
  name: 'Load',
}
